import React, { useEffect, useState, useCallback } from 'react';
import { EnumDropdown, DefaultDropdownProps } from 'framework/form';
import useTechnologyService, { Technology } from '../technology/technologyService';
import { get } from 'lodash';

interface TechnologyDropdownProps extends Omit<DefaultDropdownProps, 'options'> {
  idSource?: string;
  customReduce?: (technologies: Technology[]) => Dictionary<string>;
  deps?: any[];
}

const TechnologyDropdown = ({ idSource = 'id', customReduce, deps = [], ...props }: TechnologyDropdownProps) => {
  const [options, setOptions] = useState<Dictionary<string>>({});
  const { findAll } = useTechnologyService();

  const buildOptions = useCallback(
    (technologies: Technology[]) => {
      if (customReduce) {
        return customReduce(technologies);
      }

      return technologies.reduce(
        (result, technology) => ({
          ...result,
          [get(technology, idSource)]: technology.name,
        }),
        {} as Dictionary<string>,
      );
    },
    [customReduce, idSource],
  );

  useEffect(() => {
    const fetchTechnologies = async () => {
      try {
        const technologies = await findAll();
        const optionMap = buildOptions(technologies);
        setOptions(optionMap);
      } catch (error) {
        setOptions({});
      }
    };

    fetchTechnologies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps]);

  return <EnumDropdown {...props} options={options} />;
};

export default TechnologyDropdown;
